import { render } from "./UpdatesModal.vue?vue&type=template&id=f036c570&scoped=true"
import script from "./UpdatesModal.vue?vue&type=script&lang=js"
export * from "./UpdatesModal.vue?vue&type=script&lang=js"

import "./UpdatesModal.vue?vue&type=style&index=0&id=f036c570&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f036c570"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QList from 'quasar/src/components/item/QList.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QBtn,QList,QExpansionItem,QItemSection,QSeparator,QCardSection});
